module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/proposal-approver/component/proposal-approver/proposal-approver.component.scss
// module id = ./src/app/proposal-approver/component/proposal-approver/proposal-approver.component.scss
// module chunks = main